import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { ButtonIcon, ButtonSize } from '@prisjakt/ui/button';
import { IconClose } from '@prisjakt/ui/icon';
import { Behavior, FontWeight } from '@prisjakt/ui/text';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import {
  FilterUIPlacementEnum,
  IFilter,
} from 'src/components/price-list/types';
import {
  ScrollingFiltersList,
  ScrollingFiltersListWrapper,
  StyledButtonText,
  StyledClearButton,
  StyledTick,
} from '../styles';

interface IActiveFiltersTicks {
  activeFilters: IFilter[];
}

export const ActiveFiltersTicks = (props: IActiveFiltersTicks) => {
  const { activeFilters } = props;
  const { t } = useAppContext();
  const {
    getTranslatedLabel,
    resetFiltersByPlacement,
    toggleFilter,
  } = useOfferListFilterContext();

  if (activeFilters.length <= 0) {
    return null;
  }

  const activeFilterComponents = activeFilters.map(filter => {
    const label = getTranslatedLabel(t, filter.type);
    let prefix = '';

    if (filter.additive) {
      prefix = t('filter', 'prefix.add');
    }
    return (
      <li key={label}>
        <StyledTick
          size={ButtonSize.SMALL}
          onClick={() => toggleFilter(filter.type)}
        >
          <StyledButtonText
            behavior={Behavior.OnelineEllipsis}
            weight={FontWeight.NORMAL}
          >
            {`${prefix}${label}`}
          </StyledButtonText>
          <ButtonIcon>
            <IconClose />
          </ButtonIcon>
        </StyledTick>
      </li>
    );
  });

  let clearFilterButton;

  if (activeFilterComponents.length >= 2) {
    clearFilterButton = (
      <li>
        <StyledClearButton
          size={ButtonSize.SMALL}
          onClick={() =>
            resetFiltersByPlacement(FilterUIPlacementEnum.FILTER_MENU)
          }
        >
          {t('filter', 'button.clear-filter')}
        </StyledClearButton>
      </li>
    );
  }

  return (
    <ScrollingFiltersList>
      <ScrollingFiltersListWrapper>
        {activeFilterComponents}
        {clearFilterButton}
      </ScrollingFiltersListWrapper>
    </ScrollingFiltersList>
  );
};
